/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FinishContainerEntry } from '../../models/finish-container-entry';

export interface FinishContainer$Params {
  externalProductionOrderId: string;
      body: FinishContainerEntry
}

export function finishContainer(http: HttpClient, rootUrl: string, params: FinishContainer$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, finishContainer.PATH, 'post');
  if (params) {
    rb.path('externalProductionOrderId', params.externalProductionOrderId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

finishContainer.PATH = '/api/v1/PackLine/productionOrders/{externalProductionOrderId}/finishContainer';
